export default __webpack_public_path__ + "9faf11b848a4db3fefa0a7e095244b7a.png";